import { Component, inject } from '@angular/core';
import { FilterListRoutingService } from 'gung-list';
import { AssortmentTreeNavigationComponent } from 'gung-standard';

@Component({
    selector: 'sjoborg-assortment-tree-navigation',
    templateUrl: './sjoborg-assortment-tree-navigation.component.html',
    styleUrls: ['./sjoborg-assortment-tree-navigation.component.scss'],
    standalone: false
})
export class SjoborgAssortmentTreeNavigationComponent extends AssortmentTreeNavigationComponent {
  protected filterListRoutingService = inject(FilterListRoutingService);

  getDocuments() {
    if (this.currentAssortment && this.currentAssortment.extra.documents) {
      this.currentAssortment.documents = [];
      const baseUrl = 'https://cdn2.gung.io/';
      const documents: { name: string; url: string }[] = [];

      for (const doc of this.currentAssortment.extra.documents) {
        let name: string;
        if (doc.i18n && doc.i18n[this.currentLang]) {
          name = doc.i18n[this.currentLang].description;
        }
        if (!name && doc.extra.i18n && doc.extra.i18n[this.currentLang]) {
          name = doc.extra.i18n[this.currentLang].description;
        }
        if (!name) {
          name = doc.name;
        }
        documents.push({
          name: name || 'TECHINCAL_CHARACTERISTICS_CATALOG',
          url: baseUrl + doc.s3Uri + '?etag=' + doc.s3ETag
        });
      }
      this.currentAssortment.documents = documents;
    }
  }
}
